import React from "react";
import { Icon } from "@cadmakers-ui/icons";
import { BadgeButton } from "../../Layout/Components/BadgeButton/BadgeButton";
import { Topic } from "../Models/Topic";
import ElementSpacer from "../../Layout/Components/ElementSpacer";
import { TopicType } from "../Enums/TopicType";
import iconStyles from "../../Common/Styles/Icons.module.scss";

type Props = {
  topic: Topic;
};

export const TopicTypeBadge: React.FC<Props> = props => {
  let icon;

  switch (props.topic.type) {
    case TopicType.Public:
      icon = (
        <Icon
          appName="GeneralLayout"
          assetName="GENERAL_L_Public_20"
          className={iconStyles.smallIcon}
        />
      );
      break;
    case TopicType.Private:
      icon = (
        <Icon appName="GeneralLayout" assetName="GENERAL_L_Lock" className={iconStyles.smallIcon} />
      );
      break;
    default:
      throw new Error(`Invalid topic type "${props.topic.type}"`);
  }

  return (
    <BadgeButton disabled>
      <ElementSpacer spacing=".25rem">
        <span>{icon}</span>
        {props.topic.type}
      </ElementSpacer>
    </BadgeButton>
  );
};
